import axios from 'axios'

const baseUrl = 'https://services.vrify.com/v2'

export default {
  fetchModels (params) {
    return axios({
      method: 'get',
      url: baseUrl + '/model/',
      params: params
    }).then(response => {
      return response
    })
      .catch(e => {
        console.log(e)
      })
  },
  fetchModel (params, id) {
    return axios({
      method: 'get',
      url: baseUrl + '/model/' + id + '/',
      params: params
    }).then(response => {
      return response
    })
      .catch(e => {
        console.log(e)
      })
  },
  fetchGridModel (params, id) {
    return axios({
      method: 'get',
      url: baseUrl + '/modelgrid/' + id + '/',
      params: params
    }).then(response => {
      return response
    })
      .catch(e => {
        console.log(e)
      })
  },
  fetchSpotPrices (params) {
    return new Promise((resolve, reject) => {
      resolve(
        {
          data: {
            delayStartYear: 0,
            goldPrice: 1957,
            silverPrice: 25.14,
            copperPrice: 10163,
            molybdenumPrice: 43372,
            rheniumPrice: 2215000,
            USDCAD: 1.2484
          }
        }
      )
    })
  }
}
